import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/assignments/'
const ITEM_ID  = 'ass_id'

export const useAssignmentStore = defineStore('assignments', {
  //storage option
  persist: false,
  // convert to a function
  state: () => ({
    item: {
        ass_sit_id_old: null, ass_sit_id: null, ass_sta_id: 'GEN01', ass_typ_id: 'ASH01', ass_typ_id_dep:'ASR01', ass_typ_id_arr:'ASR01',  ass_customfields: { ass_death: 0 },
        _pivot: { livestocks: [] }
    },
    itemList: []
  }),
  getters: {

  },
  actions: {
    fetchItem (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id > 0 ){
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    if( !response.data.data.ass_customfields || Object.prototype.toString.call( response.data.data.ass_customfields ) === '[object Array]' ) {
                        response.data.data.ass_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItems (options) {
        return new Promise( (resolve, reject) => {
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaTask = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_ITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    storeItem () {
        return new Promise( (resolve, reject) => {
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
            this.SET_ITEM(response.data.data)
            resolve(this.item)
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    updateItem () {
        return new Promise( (resolve, reject) => {
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
            this.SET_ITEM(response.data)
            resolve(this.item)
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    destroyItem (id) {
        return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                this.RESET_ITEM()
            resolve('resolved')
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
      this.item._pivot= { livestocks: [] }
      this.item._pivot['livestocks']     = (this.item.livestocks) ? [...this.item.livestocks.map(a => a['lst_id'])] : []
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    RESET_ITEM () {
        this.item = {
            ass_sit_id_old: null,
            ass_sit_id: null,
            ass_sta_id: 'GEN01',
            ass_typ_id: 'ASH01', 
            ass_typ_id_dep:'ASR01',
            ass_typ_id_arr:'ASR01',
            ass_customfields: { ass_death: 0 },
            _pivot: { livestocks: [] }
        }
    }
  }
})
